module.exports = __webpack_public_path__ + "static/media/CenturyGothic-Bold.bc420c1c.ttf";